export interface ReaderPage {
  seq: number;
  label: string;
  src: string;
}

export const readerPages: ReaderPage[] = [
  {
    seq: 1,
    label: "第 1 页",
    src: "https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20calm%20opening%20panel%20of%20a%20young%20swordsman%20standing%20on%20a%20hill%20looking%20at%20a%20distant%20village%20at%20sunrise%2C%20ink%20lineart%2C%20various%20panel%20sizes%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-01&orientation=portrait",
  },
  {
    seq: 2,
    label: "第 2 页",
    src: "https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20close%20up%20panel%20of%20the%20swordsman%20drawing%20his%20blade%20from%20the%20sheath%20with%20tense%20eyes%2C%20dramatic%20ink%20lineart%2C%20dynamic%20panel%20layout%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-02&orientation=portrait",
  },
  {
    seq: 3,
    label: "第 3 页",
    src: "https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20action%20panel%20of%20two%20swordsmen%20clashing%20blades%20with%20speed%20lines%2C%20bold%20ink%20lineart%2C%20explosive%20impact%20sparks%2C%20high%20contrast%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-03&orientation=portrait",
  },
  {
    seq: 4,
    label: "第 4 页",
    src: "https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20climax%20panel%20of%20the%20swordsman%20leaping%20high%20in%20the%20air%20for%20a%20powerful%20downward%20strike%2C%20dramatic%20angle%2C%20flowing%20action%20lines%2C%20dark%20screentones%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-04&orientation=portrait",
  },
  {
    seq: 5,
    label: "第 5 页",
    src: "https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20aftermath%20panel%20of%20the%20swordsman%20sheathing%20his%20blade%20amidst%20falling%20leaves%2C%20calm%20moment%20with%20wide%20panel%2C%20soft%20ink%20lineart%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-05&orientation=portrait",
  },
  {
    seq: 6,
    label: "第 6 页",
    src: "https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20epilogue%20panel%20of%20the%20swordsman%20walking%20toward%20the%20horizon%20silhouetted%20against%20a%20setting%20sun%2C%20cinematic%20composition%2C%20fine%20ink%20lineart%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-06&orientation=portrait",
  },
];

export interface Chapter {
  id: number;
  title: string;
  pages: number;
  isNew?: boolean;
}

export const chapters: Chapter[] = [
  { id: 128, title: "第128话 · 炎刃觉醒", pages: 26, isNew: true },
  { id: 127, title: "第127话 · 破晓的约定", pages: 24 },
  { id: 126, title: "第126话 · 风与火", pages: 25 },
  { id: 125, title: "第125话 · 夜行者", pages: 23 },
  { id: 124, title: "第124话 · 重逢", pages: 27 },
  { id: 123, title: "第123话 · 无声的战场", pages: 24 },
  { id: 122, title: "第122话 · 信", pages: 22 },
  { id: 121, title: "第121话 · 雪落之日", pages: 26 },
];